export default __webpack_public_path__ + "static/media/trade_hk_07.95fb89fd.png";